{
  "common.yes": {
    "text": "ஆம்",
    "sourceHash": "b3a43630",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.no": {
    "text": "இல்லை",
    "sourceHash": "61e6be1a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.related": {
    "text": "தொடர்புடையவை",
    "sourceHash": "6faf59d8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.relatedNav": {
    "text": "தொடர்புடைய பக்கங்கள்",
    "sourceHash": "6dc7db40",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.breadcrumb": {
    "text": "பக்க வழித்தடம்",
    "sourceHash": "30635f6c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.home": {
    "text": "முகப்பு",
    "sourceHash": "10b8c84e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "cite.title": {
    "text": "மூலம்: {{label}} (சரிபார்த்தது {{date}})",
    "sourceHash": "01792346",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.home.title": {
    "text": "சிங்கப்பூர் GST InvoiceNow தேவை (IRAS): வழிகாட்டி & சரிபார்ப்புப் பட்டியல்",
    "sourceHash": "5f393811",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.home.description": {
    "text": "சிங்கப்பூரின் GST InvoiceNow Requirement பற்றிய எளிய வழிகாட்டி: ஐந்து படிச் சரிபார்ப்புப் பட்டியல், முக்கியத் தேதிகள், இலவச மென்பொருள், மானியங்கள்; ஒவ்வொன்றும் IRAS, IMDA ஆதாரத்துடன்.",
    "sourceHash": "2e5f836d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.home.crumb": {
    "text": "முகப்பு",
    "sourceHash": "52f50eae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.home.llms": {
    "text": "InvoiceNow என்றால் என்ன, அதன் பயன்கள், ஐந்து படிச் சரிபார்ப்புப் பட்டியல், வரவிருக்கும் IRAS நிகழ்வுகள், கேள்விகளை யாரிடம் கேட்பது.",
    "sourceHash": "bb1cdd91",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.title": {
    "text": "சிங்கப்பூரில் GST InvoiceNow-ஐ அமைப்பது எப்படி: 5 படிகள்",
    "sourceHash": "4bfb45a3",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.description": {
    "text": "சிங்கப்பூரில் GST-பதிவு செய்த வணிகங்களுக்கான படிப்படியான InvoiceNow அமைப்பு: உங்கள் தேதியைச் சரிபாருங்கள், InvoiceNow-Ready மென்பொருளைத் தேர்ந்தெடுங்கள், Peppol ID பெறுங்கள், IRAS-க்குச் சமர்ப்பிப்பை இயக்கிச் சோதியுங்கள்.",
    "sourceHash": "fdf14cc2",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.crumb": {
    "text": "அமைப்பு வழிகாட்டி",
    "sourceHash": "f3664512",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.nav": {
    "text": "அமைப்பு",
    "sourceHash": "0837a3d6",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.llms": {
    "text": "GST InvoiceNow தேவைக்குத் தயாராவதற்கான ஐந்து படிகள், ஒவ்வொன்றும் அதிகாரப்பூர்வ மூலத்துடன், Peppol ID தேடல், InvoiceNow-ஐப் பயன்படுத்த எங்கே உள்நுழைவது.",
    "sourceHash": "1c626952",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.title": {
    "text": "GST InvoiceNow எப்போது பொருந்தும்? கட்டங்களும் தேதிக் கணிப்பானும்",
    "sourceHash": "09845b8b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.description": {
    "text": "1 நவம்பர் 2025 முதல் 1 ஏப்ரல் 2031 வரையிலான GST InvoiceNow கட்டங்கள், விநியோகங்கள், புதிய பதிவாளர்கள், GST குழுக்களுக்கு IRAS கேள்வி-பதிலைப் பின்பற்றும் தேதிக் கணிப்பான்.",
    "sourceHash": "e161b889",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.crumb": {
    "text": "எப்போது பொருந்தும்",
    "sourceHash": "f454ea0a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.nav": {
    "text": "எப்போது",
    "sourceHash": "021e3a39",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.llms": {
    "text": "நடைமுறைக் கால அட்டவணையும் தேதிக் கணிப்பான் விதிகளும் (IRAS கேள்வி-பதில் Q1.5 முதல் Q1.12, Q7.2).",
    "sourceHash": "ca1ed4d8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.title": {
    "text": "GST InvoiceNow மென்பொருள்: இலவசத் தொகுப்புகள், வழங்குநர்கள், மானியங்கள்",
    "sourceHash": "5fde6215",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.description": {
    "text": "இலவச InvoiceNow தொகுப்புகள், Xero, AutoCount, ABSS, SAP Business One, QuickBooks போன்ற மென்பொருள்கள் IMDA-வின் InvoiceNow-Ready பட்டியலில் உள்ளனவா, வழங்குநரைக் கண்டறிவது எப்படி.",
    "sourceHash": "417bbf11",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.crumb": {
    "text": "மென்பொருளும் மானியங்களும்",
    "sourceHash": "a862ba00",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.nav": {
    "text": "மென்பொருளும் மானியங்களும்",
    "sourceHash": "a862ba00",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.llms": {
    "text": "இலவசத் தொகுப்பு, IMDA-வின் InvoiceNow-Ready பட்டியலில் உள்ள பிரபலக் கணக்கியல் மென்பொருள்கள், வழங்குநர் பட்டியல்கள், இலவசத் தொகுப்பு, IRSP, அணுகல் புள்ளி ஆகியவற்றுக்கு இடையே தேர்ந்தெடுக்க ஒரு உதவிக் கருவி.",
    "sourceHash": "0f1212a3",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.title": {
    "text": "InvoiceNow மானியங்கள்: S$1,000, S$5,000 மாற்ற மானியம், Queen Bee",
    "sourceHash": "ad42ba17",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.description": {
    "text": "IMDA-வின் GST InvoiceNow மாற்ற மானியங்கள் (S$1,000, S$5,000) மற்றும் S$25,000 Queen Bee மானியம்: யார் தகுதியானவர், நிபந்தனைகள், காலக்கெடுக்கள், கோரிக்கைப் படிவங்கள், ஒவ்வொன்றும் IMDA மூலத்துடன்.",
    "sourceHash": "90531b62",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.crumb": {
    "text": "மானியங்கள்",
    "sourceHash": "8d86615a",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.nav": {
    "text": "மானியங்கள்",
    "sourceHash": "8d86615a",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.llms": {
    "text": "S$1,000, S$5,000 GST InvoiceNow மாற்ற மானியங்கள், S$25,000 Queen Bee மானியம், உற்பத்தித்திறன் தீர்வுகள் மானியம்: தகுதி, நிபந்தனைகள், காலங்கள், கோரிக்கைப் படிவங்கள்.",
    "sourceHash": "0baa9ee6",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.title": {
    "text": "GST InvoiceNow எப்படிச் செயல்படுகிறது: சமர்ப்பிப்பு வகைகள், Peppol ID",
    "sourceHash": "0e07a929",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.description": {
    "text": "InvoiceNow-இல் விலைப்பட்டியல் எப்படிச் சென்று IRAS-ஐ அடைகிறது (Type 1A, 1B, 2, 3), Peppol ID, IRSP, Access Point என்றால் என்ன, Peppol ID சரிபார்ப்பு.",
    "sourceHash": "67b0d3a4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.crumb": {
    "text": "எப்படிச் செயல்படுகிறது",
    "sourceHash": "d03ba450",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.nav": {
    "text": "எப்படிச் செயல்படுகிறது",
    "sourceHash": "d03ba450",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.llms": {
    "text": "அசைவூட்டப்பட்ட சமர்ப்பிப்பு வகைகள், உங்களுக்குத் தேவையானவை (Peppol ID, IRSP அல்லது Access Point), Peppol ID சரிபார்ப்பு.",
    "sourceHash": "2dbc2e54",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.title": {
    "text": "POS மற்றும் சில்லறைக்கு GST InvoiceNow: விற்பனைத் தரவும் ரசீதுகளும்",
    "sourceHash": "e7b4858b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.description": {
    "text": "POS அல்லது பணப் பதிவேடு மூலம் விற்றால் GST InvoiceNow Requirement என்ன அர்த்தம்: ரசீதுகள், தொகுக்கப்பட்ட விற்பனை, InvoiceNow-இல் இல்லாத வாடிக்கையாளர்கள், காலக்கெடுக்கள்.",
    "sourceHash": "3d8df85c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.crumb": {
    "text": "POS மற்றும் சில்லறை",
    "sourceHash": "a1bea913",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.nav": {
    "text": "POS & சில்லறை",
    "sourceHash": "343b7552",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.llms": {
    "text": "POS, தொகுத்த விற்பனை (IRAS கேள்வி-பதில் Q3.4, Q3.12), InvoiceNow-வில் இல்லாத வாடிக்கையாளர்கள், காலக்கெடுக்கள், ஒப்புகை எண்கள்.",
    "sourceHash": "18167dca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.title": {
    "text": "GST InvoiceNow கேள்வி-பதில்: IRAS ஆதாரத்துடன் பதில்கள்",
    "sourceHash": "5ad6879b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.description": {
    "text": "சிங்கப்பூரின் GST InvoiceNow Requirement பற்றிய சுருக்கமான பதில்கள்; ஒவ்வொரு வாக்கியமும் அதன் மூலமான IRAS கேள்வி-பதில் அல்லது e-Tax Guide பத்தியுடன் இணைக்கப்பட்டுள்ளது.",
    "sourceHash": "648fd67d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.crumb": {
    "text": "கேள்வி-பதில்",
    "sourceHash": "3ed2943b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.nav": {
    "text": "கேள்வி-பதில்",
    "sourceHash": "3ed2943b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.llms": {
    "text": "அனைத்துக் கேள்வி-பதில்களும், ஒவ்வொரு வாக்கியத்துக்கும் மூலத்துடன்.",
    "sourceHash": "aac2b357",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.title": {
    "text": "GST InvoiceNow இணைப்புகள்: IRAS, IMDA, மானியங்கள், வழங்குநர் பட்டியல்கள்",
    "sourceHash": "c174fb14",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.description": {
    "text": "அனைத்து அதிகாரப்பூர்வ GST InvoiceNow இணைப்புகளும் ஒரே இடத்தில்: IRAS e-Tax Guide, கேள்வி-பதில், IMDA மானியங்கள், தீர்வு வழங்குநர், Access Point பட்டியல்கள், ஒவ்வொன்றும் விளக்கத்துடன்.",
    "sourceHash": "34db9b6c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.crumb": {
    "text": "பயனுள்ள இணைப்புகள்",
    "sourceHash": "237d6316",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.nav": {
    "text": "இணைப்புகள்",
    "sourceHash": "9202088e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.llms": {
    "text": "அனைத்து அதிகாரபூர்வ IRAS, IMDA இணைப்புகளும், ஒவ்வொன்றுக்கும் விளக்கத்துடன்.",
    "sourceHash": "508112b9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.about.title": {
    "text": "InvoiceNow Hub பற்றி: சுயாதீனமானது, அதிகாரபூர்வமற்றது, மூலங்களுடன்",
    "sourceHash": "50517565",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.about.description": {
    "text": "InvoiceNow Hub-ஐ யார் நடத்துகிறார்கள், இது ஏன் உள்ளது, ஒவ்வொரு தகவலும் IRAS, IMDA மூலங்களுடன் எப்படிச் சரிபார்க்கப்படுகிறது, தளம் என்ன தரவைச் சேமிக்கிறது.",
    "sourceHash": "3ad6f2bf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.about.crumb": {
    "text": "பற்றி",
    "sourceHash": "58e096de",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.about.llms": {
    "text": "தளத்தை யார் நடத்துகிறார்கள், தகவல்கள் எப்படிச் சரிபார்க்கப்படுகின்றன, தனியுரிமை.",
    "sourceHash": "90448af6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.changelog.title": {
    "text": "InvoiceNow Hub மாற்றப் பதிவு: தேதி வாரியான உள்ளடக்க மாற்றங்கள்",
    "sourceHash": "bab8730a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.changelog.description": {
    "text": "InvoiceNow Hub-இல் செய்யப்பட்ட ஒவ்வொரு உள்ளடக்க மாற்றத்தின் தேதியுடன் கூடிய பொதுப் பதிவு; IRAS, IMDA மூலங்களைச் சரிபார்த்த பின் செய்த திருத்தங்கள் உட்பட.",
    "sourceHash": "346f4996",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.changelog.crumb": {
    "text": "மாற்றப் பதிவு",
    "sourceHash": "b3dc8779",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.changelog.llms": {
    "text": "தேதி வாரியான உள்ளடக்க மாற்றங்களின் பட்டியல்.",
    "sourceHash": "ff009ee8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.notfound.title": {
    "text": "பக்கம் கிடைக்கவில்லை · InvoiceNow Hub",
    "sourceHash": "2e79a110",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.notfound.description": {
    "text": "இந்த முகவரியில் பக்கம் எதுவும் இல்லை.",
    "sourceHash": "a05926c8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "banner.aria": {
    "text": "இந்தத் தளம் பற்றி",
    "sourceHash": "5c9321fd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "banner.text": {
    "text": "<b>சுயாதீன வழிகாட்டி.</b> IRAS (சிங்கப்பூர் உள்நாட்டு வருவாய் ஆணையம்) அல்லது IMDA (தகவல் தொடர்பு ஊடக மேம்பாட்டு ஆணையம்) உடன் தொடர்பில்லை. உங்கள் சொந்த விஷயத்துக்கு, <iras>IRAS</iras> அல்லது <imda>IMDA</imda>-விடம் நேரடியாகக் கேளுங்கள்.",
    "sourceHash": "dd7d33bf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "banner.about": {
    "text": "இந்தத் தளம் பற்றி",
    "sourceHash": "5c9321fd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.unofficial": {
    "text": "<b>அதிகாரபூர்வமற்ற மொழிபெயர்ப்பு.</b> ஆங்கிலப் பதிப்பே மேலோங்கும்.",
    "sourceHash": "b9879782",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.englishLink": {
    "text": "இந்தப் பக்கத்தை ஆங்கிலத்தில் படிக்கவும்",
    "sourceHash": "f26f93a5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.draft": {
    "text": "வரைவு மொழிபெயர்ப்பு, தாய்மொழியாளர் இன்னும் சரிபார்க்கவில்லை. இதை நம்ப வேண்டாம்.",
    "sourceHash": "e7c07fff",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.switcher": {
    "text": "மொழி",
    "sourceHash": "9a73db9b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.current": {
    "text": "தற்போதைய மொழி: {{language}}",
    "sourceHash": "1987a4ec",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.main": {
    "text": "முதன்மை",
    "sourceHash": "51707928",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.footer": {
    "text": "அடிக்குறிப்பு",
    "sourceHash": "575cffd2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.whatToDo": {
    "text": "நான் என்ன செய்ய வேண்டும்?",
    "sourceHash": "0df3ccb7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.whatToDoShort": {
    "text": "என்ன செய்வது",
    "sourceHash": "cf2e345d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.question": {
    "text": "எனக்கு ஒரு கேள்வி",
    "sourceHash": "537be29b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.openMenu": {
    "text": "பட்டியைத் திற",
    "sourceHash": "b79c01dc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.closeMenu": {
    "text": "பட்டியை மூடு",
    "sourceHash": "58ee52ce",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.overview": {
    "text": "கண்ணோட்டம்",
    "sourceHash": "6a494fba",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.privacy": {
    "text": "தனியுரிமை",
    "sourceHash": "ebfa87e7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "footer.disclaimer": {
    "text": "சுயாதீன தகவல் மையம், IRAS அல்லது IMDA உடன் தொடர்பில்லை. ஒவ்வொரு தகவலும் அதன் மூலமான IRAS அல்லது IMDA ஆவணத்துடன் இணைக்கப்பட்டுள்ளது; கடைசியாக {{date}} அன்று சரிபார்க்கப்பட்டது. எப்போதும் அதிகாரபூர்வ மூலத்துடன் உறுதிப்படுத்துங்கள்; உங்கள் சொந்த விஷயம் பற்றிய கேள்விகளை <iras>IRAS</iras> அல்லது <imda>IMDA</imda>-விடம் கேளுங்கள்.",
    "sourceHash": "89524644",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "footer.made": {
    "text": "சிங்கப்பூரில் <heart>♥</heart> உடன் உருவாக்கப்பட்டது",
    "sourceHash": "8fb48457",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "footer.love": {
    "text": "அன்பு",
    "sourceHash": "d52792d1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "footer.updated": {
    "text": "கடைசியாகப் புதுப்பித்தது {{date}}",
    "sourceHash": "ef1dfe86",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "welcome.loading": {
    "text": "InvoiceNow Hub ஏற்றப்படுகிறது",
    "sourceHash": "e69aca57",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "welcome.top": {
    "text": "சுயாதீன வழிகாட்டி",
    "sourceHash": "9f78118d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "welcome.place": {
    "text": "சிங்கப்பூர் · {{year}}",
    "sourceHash": "94ed3b21",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "welcome.tagline": {
    "text": "GST INVOICENOW REQUIREMENT, ஒரே இடத்தில்",
    "sourceHash": "0dc4b2b9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.srTitle": {
    "text": "InvoiceNow: சிங்கப்பூர் வணிகங்களுக்கான GST InvoiceNow Requirement, ஒரே இடத்தில்",
    "sourceHash": "17bc1a98",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.fig1": {
    "text": "படம் 01 — சிங்கப்பூர் வணிகங்கள் ஒன்றுக்கொன்று நேரடியாக மின்-விலைப்பட்டியல் அனுப்புகின்றன",
    "sourceHash": "f160cfda",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.fig2": {
    "text": "படம் 02 — மின்-விலைப்பட்டியல் சிங்கப்பூரை வட்டாரத்துடனும் உலகத்துடனும் இணைக்கிறது",
    "sourceHash": "5cb25fb0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.einvoice": {
    "text": "மின்-விலைப்பட்டியல்",
    "sourceHash": "59faa2c6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.inOnePlace": {
    "text": "ஒரே இடத்தில்",
    "sourceHash": "b01ebb29",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.lead": {
    "text": "GST InvoiceNow Requirement (GST மின்-விலைப்பட்டியல் தேவை) என்றால் என்ன, அது உங்கள் வணிகத்துக்கு எப்போது பொருந்தும், அடுத்து என்ன செய்வது.",
    "sourceHash": "54df4707",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.lastVerified": {
    "text": "அதிகாரபூர்வ மூலங்களுடன் கடைசியாகச் சரிபார்த்தது: {{date}}",
    "sourceHash": "fd6c7239",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.cta": {
    "text": "சரிபார்ப்புப் பட்டியலைத் தொடங்கு",
    "sourceHash": "f72c8cac",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.mapAria": {
    "text": "அசைவூட்ட வரைபடம்: சிங்கப்பூர் முழுவதுமுள்ள வணிகங்கள், ஒவ்வொன்றும் அதன் வணிக வகையைக் காட்டும் சின்னத்துடன், ஒன்றுக்கொன்று மின்-விலைப்பட்டியல் அனுப்புகின்றன. பின்னர் காட்சி விரிந்து, சிங்கப்பூர் ஆசிய-பசிபிக் வட்டாரத்துடன் இணைந்திருப்பதைக் காட்டும் உலக உருண்டையாகிறது.",
    "sourceHash": "4e099061",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.eyebrow": {
    "text": "01 — INVOICENOW அடிப்படைகள் 101",
    "sourceHash": "7f5a8d73",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.title": {
    "text": "InvoiceNow<br/><accent>101</accent>",
    "sourceHash": "30bd8b9a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.lead": {
    "text": "InvoiceNow என்பது சிங்கப்பூரின் தேசிய மின்-விலைப்பட்டியல் வலையமைப்பு. இங்கிருந்து தொடங்குங்கள்: அது என்ன, முதலில் என்ன செய்வது, விவரங்களை எங்கே பார்ப்பது.",
    "sourceHash": "7c228434",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.today": {
    "text": "இன்று",
    "sourceHash": "25b07d1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.with": {
    "text": "INVOICENOW உடன்",
    "sourceHash": "3ed59ed2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.supplier": {
    "text": "விற்பனையாளர்",
    "sourceHash": "82872649",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.pdf": {
    "text": "PDF",
    "sourceHash": "ae047875",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.email": {
    "text": "மின்னஞ்சல்",
    "sourceHash": "4086f1a7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.retype": {
    "text": "மீண்டும் தட்டச்சு",
    "sourceHash": "3ba5e258",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.customer": {
    "text": "வாடிக்கையாளர்",
    "sourceHash": "d03c4dd9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.network": {
    "text": "வலையமைப்பு",
    "sourceHash": "60b0d865",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.iras": {
    "text": "IRAS",
    "sourceHash": "7be84b1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.todayBody": {
    "text": "விலைப்பட்டியல் என்பது PDF அல்லது காகித நகல். வாடிக்கையாளர் அதைப் படித்து, எண்களைத் தங்கள் அமைப்பில் மீண்டும் தட்டச்சு செய்கிறார்.",
    "sourceHash": "a82ec83b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.withBody": {
    "text": "விலைப்பட்டியல் விற்பனையாளரின் மென்பொருளிலிருந்து வாடிக்கையாளரின் மென்பொருளுக்குக் கட்டமைக்கப்பட்ட தரவாக நேரடியாகச் செல்கிறது: PDF இல்லை, மீண்டும் தட்டச்சு இல்லை. GST பதிவு பெற்ற வணிகங்களுக்கு, விலைப்பட்டியல் தரவின் நகல் IRAS-க்கும் செல்கிறது.",
    "sourceHash": "6785c176",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.eyebrow": {
    "text": "விவரங்களைப் பாருங்கள்",
    "sourceHash": "71c848a7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.when.text": {
    "text": "2025 முதல் 2031 வரையிலான கட்டங்கள், IRAS கேள்வி-பதிலைப் பின்பற்றும் தேதிக் கணிப்பான்.",
    "sourceHash": "56c8cb0b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.free-software.text": {
    "text": "IMDA-வின் இலவசத் தொகுப்புகள், InvoiceNow மானியங்கள், வழங்குநரைக் கண்டுபிடிக்கும் முறை.",
    "sourceHash": "a5249cb4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.how-it-works.text": {
    "text": "விலைப்பட்டியலும் அதன் தரவும் எப்படிச் செல்கின்றன, Peppol ID, Access Point என்றால் என்ன, உங்கள் அடுத்த படிகள்.",
    "sourceHash": "4dd8b32d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.pos-and-retail.text": {
    "text": "ரசீதுகள், தொகுத்த விற்பனை, InvoiceNow-வில் இல்லாத வாடிக்கையாளர்கள்.",
    "sourceHash": "fb98cbca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.faq.text": {
    "text": "சுருக்கமான பதில்கள்; ஒவ்வொரு வாக்கியமும் அதன் மூலமான IRAS கேள்வியுடன் இணைக்கப்பட்டுள்ளது.",
    "sourceHash": "f92a335e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.links.text": {
    "text": "அனைத்து அதிகாரபூர்வ IRAS, IMDA இணைப்புகளும், ஒவ்வொன்றுக்கும் விளக்கத்துடன்.",
    "sourceHash": "508112b9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.start": {
    "text": "இங்கே தொடங்குங்கள்",
    "sourceHash": "3a69c0a3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.title": {
    "text": "இப்போது என்ன செய்வது",
    "sourceHash": "bd4b4b81",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.progress": {
    "text": "{{total}}-இல் {{done}} முடிந்தது",
    "sourceHash": "62cf8b88",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.reset": {
    "text": "பட்டியலை மீட்டமை",
    "sourceHash": "5eb00d60",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.guide": {
    "text": "முழுப் படிப்படியான வழிகாட்டி",
    "sourceHash": "766641cd",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.step": {
    "text": "படி {{n}} / {{total}}",
    "sourceHash": "291696c8",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.loginTitle": {
    "text": "InvoiceNow-க்கு உள்நுழைவு உண்டா?",
    "sourceHash": "6b0d8733",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.loginLead": {
    "text": "நீங்கள் உங்கள் InvoiceNow-Ready தீர்வின் மூலம் InvoiceNow-ஐப் பயன்படுத்துகிறீர்கள், எனவே உங்கள் வழங்குநரின் மென்பொருளில் உள்நுழைகிறீர்கள்; உங்கள் சமர்ப்பிப்புகள் அங்கேதான் தெரியும்.",
    "sourceHash": "4bc71ba0",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.trackerNote": {
    "text": "செய்யும்போதே படிகளைக் குறிக்க விரும்புகிறீர்களா?",
    "sourceHash": "bbe04031",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.trackerLink": {
    "text": "முகப்புப் பக்கத்தில் உள்ள சரிபார்ப்புப் பட்டியலைப் பயன்படுத்துங்கள்",
    "sourceHash": "a5cd9529",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.nextStep": {
    "text": "உங்கள் அடுத்த படி · {{total}}-இல் {{n}}",
    "sourceHash": "2d90689f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.allDone": {
    "text": "அனைத்துப் படிகளும் முடிந்தன 🎉",
    "sourceHash": "8400e0dc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.iDidThis": {
    "text": "இதைச் செய்துவிட்டேன்",
    "sourceHash": "22606b5a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.back": {
    "text": "பட்டியலுக்குத் திரும்பு",
    "sourceHash": "3eb56e0b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.done": {
    "text": "{{done}}/{{total}} முடிந்தது",
    "sourceHash": "f158d5f0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.region": {
    "text": "சரிபார்ப்புப் பட்டியல் குறுக்குவழி",
    "sourceHash": "ae6fc30b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.hide": {
    "text": "சரிபார்ப்புப் பட்டியல் குறுக்குவழியை மறை",
    "sourceHash": "ec623fcd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.show": {
    "text": "சரிபார்ப்புப் பட்டியல் குறுக்குவழியைக் காட்டு",
    "sourceHash": "157935ee",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.showAria": {
    "text": "சரிபார்ப்புப் பட்டியல் குறுக்குவழியைக் காட்டு, {{total}}-இல் {{done}} முடிந்தது",
    "sourceHash": "dfa0dd87",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.t": {
    "text": "உங்கள் தேதியைச் சரிபாருங்கள்",
    "sourceHash": "5fa6b1aa",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.d": {
    "text": "நீங்கள் எந்தக் கட்டத்தில் இருக்கிறீர்கள் என்று அறியுங்கள்.",
    "sourceHash": "98f79dae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.title": {
    "text": "உங்கள் தேதியைக் கண்டறியுங்கள்",
    "sourceHash": "b817b897",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.body": {
    "text": "நீங்கள் எந்தக் கட்டத்தில் இருக்கிறீர்கள் என்று பார்க்கக் கணிப்பானைப் பயன்படுத்துங்கள். IRAS உங்களுக்கு MyTaxMail (IRAS இணைய அஞ்சல்பெட்டி) மூலமும் அறிவித்திருக்க வேண்டும்; அந்தக் கடிதத்தையே பின்பற்றுங்கள்.",
    "sourceHash": "58e56ece",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.a.0": {
    "text": "தேதிக் கணிப்பானைத் திற",
    "sourceHash": "c464a842",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.a.1": {
    "text": "முழு கால அட்டவணையைப் பார்க்கவும்",
    "sourceHash": "b380042b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.t": {
    "text": "உங்கள் மென்பொருளைச் சரிபாருங்கள்",
    "sourceHash": "9f42728f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.d": {
    "text": "அது IMDA-வின் InvoiceNow-Ready பட்டியலில் உள்ளதா? இன்னும் மென்பொருள் இல்லையா? ஒன்றைத் தேர்ந்தெடுங்கள்.",
    "sourceHash": "6f91043c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.title": {
    "text": "உங்கள் மென்பொருள் InvoiceNow-Ready என்பதை உறுதிசெய்யுங்கள்",
    "sourceHash": "34412348",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.body": {
    "text": "IMDA-வின் InvoiceNow-Ready தீர்வு வழங்குநர் (IRSP) பட்டியலில் உங்கள் மென்பொருளைத் தேடுங்கள். உங்கள் சொந்த ERP அல்லது உள்ளக அமைப்பைப் பயன்படுத்தினால், IMDA அங்கீகாரம் பெற்ற Access Point (அணுகல் முனையம்) வழங்குநர் தேவை. இன்னும் மென்பொருள் இல்லையா? IMDA இலவசத் தொகுப்புகளைப் பட்டியலிட்டுள்ளது.",
    "sourceHash": "752e3c18",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.0": {
    "text": "IRSP பட்டியல்",
    "sourceHash": "c2af4eb3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.1": {
    "text": "Access Point பட்டியல்",
    "sourceHash": "f269f97f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.2": {
    "text": "என்னிடம் InvoiceNow-Ready மென்பொருள் இல்லை",
    "sourceHash": "fa95c4fe",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.3": {
    "text": "POS அல்லது சில்லறை அமைப்பைப் பயன்படுத்துகிறீர்களா?",
    "sourceHash": "02e235b8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.4": {
    "text": "தேர்ந்தெடுக்க உதவுங்கள்",
    "sourceHash": "7f98f8ed",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.t": {
    "text": "உங்கள் Peppol ID-ஐப் பெறுங்கள்",
    "sourceHash": "c53fe87f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.d": {
    "text": "உங்கள் IRSP அல்லது Access Point வழங்குநரிடம் பேசுங்கள்.",
    "sourceHash": "2f4e24f3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.title": {
    "text": "உங்கள் Peppol ID-ஐப் பெறுங்கள்",
    "sourceHash": "c53fe87f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.body": {
    "text": "உங்கள் UEN (தனித்துவ நிறுவன அடையாள எண்) கொண்டு SG Peppol Directory-இல் உங்கள் வணிகத்தைப் பதிவுசெய்யுமாறு உங்கள் IRSP அல்லது Access Point வழங்குநரிடம் கேளுங்கள். ஏற்கெனவே உங்களிடம் ஒன்று உள்ளதா என்று கீழே தேடிப் பாருங்கள்.",
    "sourceHash": "9319d07f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.a.0": {
    "text": "இலவசத் தொகுப்பு வழங்குநர்கள் என்னை அழைக்கக் கோரு",
    "sourceHash": "8b5a108e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.a.1": {
    "text": "தொடங்க உங்களுக்குத் தேவையானவை",
    "sourceHash": "3857a84c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.t": {
    "text": "GST InvoiceNow சமர்ப்பிப்பை இயக்குங்கள்",
    "sourceHash": "235ac8d3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.d": {
    "text": "உங்கள் IRSP அல்லது Access Point வழங்குநரிடம் பேசுங்கள்.",
    "sourceHash": "2f4e24f3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.title": {
    "text": "GST InvoiceNow சமர்ப்பிப்பை இயக்குங்கள்",
    "sourceHash": "235ac8d3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.body": {
    "text": "IRAS-க்கு விலைப்பட்டியல் தரவைச் சமர்ப்பிக்கத் தொடங்க, GST InvoiceNow சமர்ப்பிப்பு வசதியைச் செயல்படுத்துங்கள். உங்கள் IRSP அல்லது Access Point வழங்குநர் உதவலாம்.",
    "sourceHash": "e83f15f8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.a.0": {
    "text": "IRAS-க்குச் சமர்ப்பிப்பது எப்படிச் செயல்படுகிறது",
    "sourceHash": "a22b8b59",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.a.1": {
    "text": "கேள்வி-பதில் படிக்கவும்",
    "sourceHash": "7c14797e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.t": {
    "text": "சமர்ப்பிப்பு வெற்றிபெறுவதை உறுதிசெய்யுங்கள்",
    "sourceHash": "1c6ebe3f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.d": {
    "text": "சோதனை விலைப்பட்டியல் அனுப்பி, IRAS அதைப் பெற்றதை உறுதிசெய்யுங்கள்.",
    "sourceHash": "90f2504f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.title": {
    "text": "சமர்ப்பிப்பு வெற்றிபெறுவதை உறுதிசெய்யுங்கள்",
    "sourceHash": "bfce8736",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.body": {
    "text": "உங்கள் தேதிக்கு முன் சோதியுங்கள்; ஒவ்வொரு வெற்றிகரமான அனுப்புதலுக்கும் உங்கள் தீர்வு IRAS ஒப்புகை எண்ணை (acknowledgement ID) காட்டுவதைச் சரிபாருங்கள். உள்ளக அமைப்புகளுக்கு, அமைப்பை இணைக்க {{from}} முதல் {{to}} மாதங்கள் ஒதுக்குமாறு IRAS கூறுகிறது.",
    "sourceHash": "38d01780",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.a.0": {
    "text": "e-Tax Guide-ஐப் படியுங்கள்",
    "sourceHash": "e1863849",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.a.1": {
    "text": "IRAS இணையக் கருத்தரங்கில் சேருங்கள்",
    "sourceHash": "4e35f0a1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.a.2": {
    "text": "அனைத்து பயனுள்ள இணைப்புகள்",
    "sourceHash": "7cd30ec6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.title": {
    "text": "நீங்கள் InvoiceNow-க்குத் தயார்",
    "sourceHash": "53a66a01",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.body": {
    "text": "உங்கள் தீர்வு மூலம் விலைப்பட்டியல் தரவைத் தொடர்ந்து அனுப்புங்கள்; உங்கள் பதிவேடுகளைக் குறைந்தது 5 ஆண்டுகள் வைத்திருங்கள். நீங்கள் கோரக்கூடிய மானியங்களைச் சரிபாருங்கள்; உங்கள் வணிகப் பங்காளிகள் உங்களுக்கு மின்-விலைப்பட்டியல் அனுப்பலாம் என்று அவர்களிடம் சொல்லுங்கள்.",
    "sourceHash": "ec58230d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.a.0": {
    "text": "கிடைக்கும் மானியங்கள்",
    "sourceHash": "56883285",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.a.1": {
    "text": "வரவிருக்கும் நிகழ்வுகள்",
    "sourceHash": "484376c0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.a.2": {
    "text": "எனக்கு ஒரு கேள்வி",
    "sourceHash": "537be29b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.eyebrow": {
    "text": "02 — வரவிருக்கும் நிகழ்வுகள்",
    "sourceHash": "05eca34c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.title": {
    "text": "<accent>நேரலையில்</accent> கற்றுக்கொள்ளுங்கள்",
    "sourceHash": "56984197",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.signup": {
    "text": "பதிவுசெய்",
    "sourceHash": "6a7d7331",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.details": {
    "text": "விவரங்கள்",
    "sourceHash": "0ec24245",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.none": {
    "text": "இப்போது பதிவுக்குத் திறந்திருக்கும் நிகழ்வுகள் எதுவும் இல்லை. <lnk>IRAS நிகழ்வுகள் பக்கத்தைப் பாருங்கள்</lnk>",
    "sourceHash": "896a0649",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.source": {
    "text": "<lnk>IRAS நிகழ்வுகள் பக்கத்திலிருந்து</lnk> பட்டியலிடப்பட்டது. பதிவு திறப்பதும் மூடுவதும் IRAS தரப்பில் நடக்கிறது; சமீபத்திய நிலைக்கு அந்தப் பக்கத்தைப் பாருங்கள்.",
    "sourceHash": "b3c0894c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.asOf": {
    "text": "{{date}} நிலவரப்படி நிகழ்வுப் பட்டியல்.",
    "sourceHash": "41c4773a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.eyebrow": {
    "text": "03 — எனக்கு ஒரு கேள்வி",
    "sourceHash": "7668c750",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.title": {
    "text": "<accent>சரியானவர்களிடம்</accent> கேளுங்கள்",
    "sourceHash": "29b27cc1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.lead": {
    "text": "இந்தத் தளம் சுயாதீனமானது; உங்கள் நிலைமை பற்றி ஆலோசனை கூற முடியாது. உங்கள் சொந்த விஷயம் தொடர்பான எதற்கும், கீழே உள்ள அதிகாரபூர்வ IRAS, IMDA தொடர்புப் படிவங்களைப் பயன்படுத்துங்கள்.",
    "sourceHash": "a3135ddb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.allLinks": {
    "text": "அனைத்துப் பயனுள்ள இணைப்புகளையும் பார்",
    "sourceHash": "f90ceca2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.faq": {
    "text": "பொதுவான கேள்விகள்",
    "sourceHash": "97c33d95",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.setup.eyebrow": {
    "text": "அமைப்பு வழிகாட்டி",
    "sourceHash": "31e53132",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.setup.title": {
    "text": "InvoiceNow-ஐ <accent>ஐந்து படிகளில் அமையுங்கள்</accent>",
    "sourceHash": "97d06ea2",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.setup.intro": {
    "text": "GST InvoiceNow தேவைக்குத் தயாராக: உங்கள் நடைமுறைப்படுத்தும் தேதியைக் கண்டறியுங்கள், உங்கள் மென்பொருள் InvoiceNow-Ready ஆனதா என்று சரிபாருங்கள் (அல்லது இலவசத் தொகுப்பைத் தேர்ந்தெடுங்கள்), உங்கள் வழங்குநர் மூலம் Peppol ID பெறுங்கள், GST InvoiceNow சமர்ப்பிப்பை இயக்குங்கள், உங்கள் விலைப்பட்டியல் தரவை IRAS ஒப்புக்கொள்வதை உறுதிசெய்யுங்கள்.",
    "sourceHash": "7c1162fc",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.when.eyebrow": {
    "text": "எப்போது பொருந்தும்",
    "sourceHash": "ddfdfa4a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.when.title": {
    "text": "GST InvoiceNow <accent>உங்களுக்கு எப்போது பொருந்தும்</accent>",
    "sourceHash": "4fe55c11",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.when.intro": {
    "text": "GST InvoiceNow Requirement 2025 முதல் 2031 வரை கட்டம் கட்டமாக அமலாகிறது. கால அட்டவணையில் உங்கள் கட்டத்தைக் கண்டறியுங்கள், அல்லது கணிப்பானில் சில கேள்விகளுக்குப் பதிலளியுங்கள். IRAS-இன் MyTaxMail கடிதம் உங்களிடம் இருந்தால் அதையே பின்பற்றுங்கள்.",
    "sourceHash": "3b4b34a1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.free-software.eyebrow": {
    "text": "மென்பொருளும் மானியங்களும்",
    "sourceHash": "026adb00",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.free-software.title": {
    "text": "InvoiceNow மென்பொருள் <accent>மற்றும் மானியங்கள்</accent>",
    "sourceHash": "c3422fc6",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.free-software.intro": {
    "text": "GST பதிவு பெற்ற வணிகங்களுக்கான இலவச InvoiceNow தொகுப்புகளை IMDA பட்டியலிடுகிறது; சந்தாக்களுக்கும் உங்கள் சொந்த அமைப்பை இணைப்பதற்கும் மானியங்களையும் வழங்குகிறது.",
    "sourceHash": "c061b87b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.grants.eyebrow": {
    "text": "மானியங்கள்",
    "sourceHash": "e51cbffa",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.grants.title": {
    "text": "InvoiceNow <accent>மானியங்கள்</accent>",
    "sourceHash": "07424232",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.grants.intro": {
    "text": "உங்கள் வணிகம் GST InvoiceNow-இல் சேர IMDA ரொக்க மானியங்களை வழங்குகிறது: உங்கள் வணிக அளவுக்கு ஏற்ற மாற்ற மானியம், உங்கள் சொந்த ERP-ஐ இணைக்கப் பெரிய மானியம். சந்தா செலுத்தும் அல்லது திட்டத்தைத் தொடங்கும் முன் எது பொருந்தும் என்று சரிபாருங்கள்: நீங்கள் எப்போது பதிவுசெய்கிறீர்கள், முன்பு எதைப் பயன்படுத்தினீர்கள் என்பதை நிபந்தனைகள் உள்ளடக்குகின்றன.",
    "sourceHash": "062d6627",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.how-it-works.eyebrow": {
    "text": "எப்படிச் செயல்படுகிறது",
    "sourceHash": "686e8db0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.how-it-works.title": {
    "text": "GST InvoiceNow <accent>எப்படிச் செயல்படுகிறது</accent>",
    "sourceHash": "72d86e15",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.how-it-works.intro": {
    "text": "InvoiceNow-வில் விலைப்பட்டியலும் அதன் தரவும் எப்படிச் செல்கின்றன, பங்கேற்க என்ன தேவை, உங்கள் அடுத்த படியைக் காட்டும் ஒரு சிறிய சரிபார்ப்புக் கருவி.",
    "sourceHash": "c8b6e0d7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.pos-and-retail.eyebrow": {
    "text": "POS மற்றும் சில்லறை",
    "sourceHash": "69cfe073",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.pos-and-retail.title": {
    "text": "<accent>POS மற்றும் சில்லறை</accent> வணிகங்களுக்கான GST InvoiceNow",
    "sourceHash": "93ab4774",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.pos-and-retail.intro": {
    "text": "விற்பனை முனைய அமைப்பு (POS) அல்லது பணப் பதிவேடு மூலம் பொதுமக்களுக்கு விற்றால், தேவையின் இந்தப் பகுதிகளே உங்களுக்கு மிக முக்கியம்.",
    "sourceHash": "c861edd4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.faq.eyebrow": {
    "text": "கேள்வி-பதில்",
    "sourceHash": "3ed2943b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.faq.title": {
    "text": "GST InvoiceNow <accent>கேள்விகள்</accent>",
    "sourceHash": "0a7f8a21",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.faq.intro": {
    "text": "GST InvoiceNow Requirement பற்றிய பொதுவான கேள்விகளுக்கு எளிய மொழியில் பதில்கள், வாக்கியம் வாக்கியமாக மூலங்களுடன்.",
    "sourceHash": "1fe05500",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.eyebrow": {
    "text": "கால அட்டவணை",
    "sourceHash": "bc44f6d6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.title": {
    "text": "யார் சேர்கிறார்கள், <accent>எப்போது</accent>",
    "sourceHash": "9d560600",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.lead": {
    "text": "2025 முதல் 2031 வரை கட்டம் கட்டமாக. நீங்கள் ஏற்கெனவே GST பதிவு பெற்றிருந்தால், உங்கள் கட்டம் உங்கள் மொத்த ஆண்டு விநியோகங்களைப் பொறுத்தது.",
    "sourceHash": "28b2be96",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.inEffect": {
    "text": "● நடைமுறையில் உள்ளது",
    "sourceHash": "5d7236da",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.next": {
    "text": "○ அடுத்தது · {{until}}",
    "sourceHash": "1017e15a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.future": {
    "text": "○ {{until}}",
    "sourceHash": "21f6174a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.cta": {
    "text": "உங்கள் நடைமுறைத் தேதியைச் சரிபாருங்கள்",
    "sourceHash": "17b63db8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.source": {
    "text": "மூலம்: <lnk>{{label}}</lnk>. வரம்புகள் 2025-இல் முடிவடையும் காலங்களின் மொத்த ஆண்டு விநியோகங்கள் ஆகும்.",
    "sourceHash": "b4b776f5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "until.inEffect": {
    "text": "நடைமுறையில் உள்ளது",
    "sourceHash": "208f4e47",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "until.underMonth": {
    "text": "ஒரு மாதத்துக்கும் குறைவு",
    "sourceHash": "53c8f61a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "until.oneMonth": {
    "text": "இன்னும் 1 மாதம்",
    "sourceHash": "b8ad03cc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "until.months": {
    "text": "இன்னும் {{count}} மாதங்கள்",
    "sourceHash": "e7211b5b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.eyebrow": {
    "text": "கணிப்பான்",
    "sourceHash": "b195868d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.title": {
    "text": "GST InvoiceNow நடைமுறைத் தேதிக் கணிப்பான்",
    "sourceHash": "386f86e8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.mytaxmailLead": {
    "text": "உங்கள் IRAS MyTaxMail கடிதத்தையே பின்பற்றுங்கள்.",
    "sourceHash": "80d5ce30",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.indicative": {
    "text": "இந்தக் கணிப்பான் வழிகாட்டலுக்கு மட்டுமே. IRAS தனது சொந்தக் <lnk>கணிப்பான் விரிதாளையும்</lnk> வெளியிட்டுள்ளது.",
    "sourceHash": "717145b9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q1": {
    "text": "1. உங்கள் வணிகத்தை எது சிறப்பாக விவரிக்கிறது?",
    "sourceHash": "a173820f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.existing": {
    "text": "ஏற்கெனவே GST பதிவு பெற்றது",
    "sourceHash": "885dfae4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.voluntary": {
    "text": "தன்னார்வமாகப் பதிவுசெய்கிறது",
    "sourceHash": "72a133ab",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.compulsory": {
    "text": "கட்டாயமாகப் பதிவுசெய்கிறது",
    "sourceHash": "46f29b7e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.group": {
    "text": "GST குழுவின் பகுதி",
    "sourceHash": "4d8261d7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.excluded": {
    "text": "வெளிநாட்டு நிறுவனம், அல்லது தலைகீழ் வரி விதிப்பால் மட்டுமே பதிவுசெய்தது",
    "sourceHash": "29b09196",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.notRegistered": {
    "text": "GST பதிவு பெறவில்லை",
    "sourceHash": "56e0842f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q1hint": {
    "text": "கட்டாயப் பதிவுக்கு விண்ணப்பித்து, தன்னார்வப் பதிவாக அங்கீகரிக்கப்பட்டதா? இதைத் தேர்ந்தெடுங்கள் (IRAS கேள்வி-பதில் Q1.6).",
    "sourceHash": "17e96b52",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q2": {
    "text": "2. GST பதிவுக்கு எப்போது விண்ணப்பித்தீர்கள் (அல்லது விண்ணப்பிப்பீர்கள்)?",
    "sourceHash": "b41b4c75",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q2hint": {
    "text": "விண்ணப்பத் தேதியே கணக்கில் கொள்ளப்படும், அங்கீகாரத் தேதி அல்ல (IRAS கேள்வி-பதில் Q1.7).",
    "sourceHash": "5ffa4140",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q3": {
    "text": "3. விண்ணப்பத்துக்கு முந்தைய 6 மாதங்களுக்குள் நிறுவனம் நிறுவப்பட்டதா?",
    "sourceHash": "cf03eefe",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q4": {
    "text": "4. அதன் பதிவு சிங்கப்பூருக்கு மாற்றப்பட்டதா?",
    "sourceHash": "504df8b1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.qReturns": {
    "text": "{{n}}. 2025-இல் முடிவடையும் கணக்கியல் காலங்களுக்கான GST அறிக்கைகள் உங்களிடம் உள்ளனவா?",
    "sourceHash": "9b61dc20",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.returnsYes": {
    "text": "ஆம், பூஜ்ஜிய அறிக்கைகள் உட்பட",
    "sourceHash": "69f015cf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.qEnds": {
    "text": "உங்கள் கணக்கியல் காலங்கள் எந்த மாதங்களில் முடிவடைகின்றன?",
    "sourceHash": "a75ee2f9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ends.mar-jun-sep-dec": {
    "text": "மார்ச், ஜூன், செப்டம்பர், டிசம்பர்",
    "sourceHash": "898b4c44",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ends.jan-apr-jul-oct": {
    "text": "ஜனவரி, ஏப்ரல், ஜூலை, அக்டோபர்",
    "sourceHash": "bbef00f0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ends.feb-may-aug-nov": {
    "text": "பிப்ரவரி, மே, ஆகஸ்ட், நவம்பர்",
    "sourceHash": "8158f7bd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ends.monthly": {
    "text": "ஒவ்வொரு மாதமும்",
    "sourceHash": "cb5eaf92",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.mar-jun-sep-dec": {
    "text": "ஜனவரி 2025 முதல் டிசம்பர் 2025 வரை",
    "sourceHash": "49706a77",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.jan-apr-jul-oct": {
    "text": "நவம்பர் 2024 முதல் அக்டோபர் 2025 வரை",
    "sourceHash": "c4fa8141",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.feb-may-aug-nov": {
    "text": "டிசம்பர் 2024 முதல் நவம்பர் 2025 வரை",
    "sourceHash": "a48f9356",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.monthly": {
    "text": "ஜனவரி 2025 முதல் டிசம்பர் 2025 வரை",
    "sourceHash": "49706a77",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.suppliesFrom": {
    "text": "{{window}} காலத்தில் உங்கள் விநியோகங்கள்",
    "sourceHash": "26e2926d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.addUp": {
    "text": "2025-இல் முடிவடையும் காலங்களுக்கான அனைத்து அறிக்கைகளையும் கூட்டுங்கள் (பெட்டி 4 மொத்தத் தொகை). பூஜ்ஜிய அறிக்கைகள் S$0 எனக் கணக்கிடப்படும்.",
    "sourceHash": "0ace1072",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.sr": {
    "text": "நிலையான வீதம் (S$)",
    "sourceHash": "3aade13f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.zr": {
    "text": "பூஜ்ஜிய வீதம் (S$)",
    "sourceHash": "6d230976",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ex": {
    "text": "விலக்கு பெற்றது (S$)",
    "sourceHash": "1f11d064",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.qFull": {
    "text": "அந்த அறிக்கைகள் முழு 12 மாதங்களையும் உள்ளடக்குகின்றனவா?",
    "sourceHash": "b8a82dfa",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.fullNo": {
    "text": "இல்லை, ஆண்டின் ஒரு பகுதி மட்டும்",
    "sourceHash": "c1e50250",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.qDays": {
    "text": "அவை எத்தனை நாட்களை உள்ளடக்குகின்றன?",
    "sourceHash": "c417b49a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.daysPlaceholder": {
    "text": "எ.கா. 61",
    "sourceHash": "d3655bec",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.empty": {
    "text": "உங்கள் கட்டத்தைக் காணக் கேள்விகளுக்குப் பதிலளியுங்கள். நீங்கள் உள்ளிடுவது உங்கள் உலாவியை விட்டு வெளியேறாது.",
    "sourceHash": "cb154492",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.phase": {
    "text": "உங்கள் கட்டம் · {{until}}",
    "sourceHash": "da4b5e54",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.from-registration": {
    "text": "பதிவு முதல் பொருந்தும்",
    "sourceHash": "3d0719b6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.iras-will-notify": {
    "text": "IRAS உங்களுக்கு அறிவிக்கும்",
    "sourceHash": "3ff33fc0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.follow-group": {
    "text": "உங்கள் GST குழுவைப் பின்பற்றுங்கள்",
    "sourceHash": "5f073b36",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.not-required": {
    "text": "தேவையில்லை",
    "sourceHash": "37ffb4d7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.date.from-registration": {
    "text": "பதிவு முதல்",
    "sourceHash": "353e846a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.date.iras-will-notify": {
    "text": "IRAS உங்களுக்குத் தெரிவிக்கும்",
    "sourceHash": "4b3e7862",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.date.follow-group": {
    "text": "உங்கள் குழுவின் தேதி",
    "sourceHash": "0a0ee677",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.date.not-required": {
    "text": "தேவையில்லை",
    "sourceHash": "457ecb17",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.total": {
    "text": "மொத்த ஆண்டு விநியோகங்கள்",
    "sourceHash": "cde45247",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.equiv": {
    "text": "(365 நாள் சமமானது)",
    "sourceHash": "a2f310c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.nextSteps": {
    "text": "என் அடுத்த படிகளைப் பார்",
    "sourceHash": "388d4b07",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ask": {
    "text": "என் விஷயம் பற்றி IRAS-இடம் கேள்",
    "sourceHash": "b149fe5e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.disclaimer": {
    "text": "வழிகாட்டலுக்கு மட்டுமே. IRAS-இன் MyTaxMail அறிவிப்பில் உள்ள தேதியே கணக்கில் கொள்ளப்படும். ERP-ஐப் பகிர்ந்துகொள்ளும், கூடுதல் காலம் தேவைப்படும் உரிமை வணிக (franchise) அல்லது அதுபோன்ற குழுவின் பகுதியா? IRAS நீட்டிப்புக் கோரிக்கைகளை ஒவ்வொன்றாகப் பரிசீலிக்கிறது (கேள்வி-பதில் Q1.14).",
    "sourceHash": "6a570cea",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.count": {
    "text": "{{count}} கேள்விகள், மூலங்களுடன்",
    "sourceHash": "2601f760",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.lead": {
    "text": "சுருக்கமான பதில்கள். ஒவ்வொரு வாக்கியமும் அதைக் கூறும் அதிகாரபூர்வ ஆவணத்துடன் இணைக்கப்பட்டுள்ளது; பெரும்பாலும் IRAS-இன் <lnk>FAQ for businesses (23 Sep 2026)</lnk>, e-Tax Guide.",
    "sourceHash": "7c81d2ae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.own": {
    "text": "உங்கள் சொந்த வணிகம் பற்றிய கேள்விகளுக்கு, <iras>IRAS வினவல் படிவம்</iras> அல்லது <imda>IMDA தொடர்புப் படிவத்தைப்</imda> பயன்படுத்துங்கள்.",
    "sourceHash": "858738e0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.imda": {
    "text": "IMDA InvoiceNow மானியங்கள்",
    "sourceHash": "adb16488",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.infographic": {
    "text": "தகவல் வரைபடம்",
    "sourceHash": "23e80f0b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.footnote": {
    "text": "மானிய விதிமுறைகள் <grants>{{grantsLabel}}</grants>-இலிருந்து. சந்தா செலுத்தும் அல்லது திட்டத்தைத் தொடங்கும் முன் IMDA-விடம் தகுதியையும் விதிமுறைகளையும் சரிபாருங்கள்.",
    "sourceHash": "c2d31e02",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.answerTitle": {
    "text": "என்னென்ன InvoiceNow மானியங்கள் உள்ளன?",
    "sourceHash": "b8ff433f",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.faqLink": {
    "text": "IMDA மானியக் கேள்விகள்",
    "sourceHash": "9ab3c874",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.faqHeading": {
    "text": "தொடர்புடைய கேள்விகள்",
    "sourceHash": "2b9de2c5",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.heading": {
    "text": "இலவசத் தொகுப்பு",
    "sourceHash": "3c70769f",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.grantsTitle": {
    "text": "InvoiceNow மானியங்கள்",
    "sourceHash": "4b5a8bf7",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.grantsBody": {
    "text": "கட்டணத் தீர்வுக்கோ உங்கள் சொந்த ERP-ஐ இணைப்பதற்கோ IMDA மாற்ற மானியங்களும் Queen Bee மானியமும்.",
    "sourceHash": "84913ce3",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.grantsLink": {
    "text": "மானியங்களைப் பாருங்கள்",
    "sourceHash": "d8b3cd8e",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.checkTitle": {
    "text": "என் கணக்கியல் மென்பொருள் InvoiceNow-Ready ஆனதா?",
    "sourceHash": "57c2b2d7",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.checkLead": {
    "text": "பிரபலமான மென்பொருள்கள் அதில் இவ்வாறு இடம்பெறுகின்றன. பட்டியல் அடிக்கடி மாறும், எனவே சமீபத்திய பதிப்பிலும் உங்கள் வழங்குநரிடமும் உறுதிசெய்யுங்கள்.",
    "sourceHash": "6f4f1b0b",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.colSoftware": {
    "text": "மென்பொருள்",
    "sourceHash": "c9f3f4b0",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.colStatus": {
    "text": "IMDA பட்டியலில் உள்ளதா?",
    "sourceHash": "386c1714",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.listed.provider": {
    "text": "ஆம், <en>{{provider}}</en> பெயரில் பட்டியலிடப்பட்டுள்ளது",
    "sourceHash": "23635794",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.listed.partners": {
    "text": "ஆம், பட்டியலிடப்பட்ட பல செயலாக்கக் கூட்டாளர்கள் மூலம்",
    "sourceHash": "1b18849f",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.listed.no": {
    "text": "பட்டியலில் இல்லை",
    "sourceHash": "31e73b8c",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.notListed": {
    "text": "பட்டியலில் இல்லையா?",
    "sourceHash": "4202fac9",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.footnote": {
    "text": "இலவசத் தொகுப்பு <foc>{{focLabel}}</foc>-இலிருந்து. சந்தா செலுத்தும் முன் IMDA-விடமும் வழங்குநரிடமும் விதிமுறைகளைச் சரிபாருங்கள்.",
    "sourceHash": "f13bab98",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.title": {
    "text": "InvoiceNow-Ready தீர்வு வழங்குநர் அல்லது Access Point வழங்குநரைக் கண்டறிதல்",
    "sourceHash": "0f89f1c0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.irsp": {
    "text": "InvoiceNow-Ready தீர்வு வழங்குநர் பட்டியல்",
    "sourceHash": "3dd2d602",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.ap": {
    "text": "Access Point பட்டியல்",
    "sourceHash": "f269f97f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.foc": {
    "text": "இலவச (FOC) தொகுப்புப் பட்டியல்",
    "sourceHash": "ddc29fb7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.callback": {
    "text": "இலவசத் தொகுப்பு வழங்குநர்கள் என்னை அழைக்கக் கோரு",
    "sourceHash": "8b5a108e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.allow": {
    "text": "ஒதுக்குங்கள்",
    "sourceHash": "40a195d2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.months": {
    "text": "<from/>–<to/> மாதங்கள்",
    "sourceHash": "2c742238",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.note": {
    "text": "உள்ளக நிறுவன அமைப்பை IRAS-உடன் இணைக்க, என்று IRAS கூறுகிறது",
    "sourceHash": "f8c89612",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "how.eyebrow": {
    "text": "விலைப்பட்டியல் எப்படிச் செல்கிறது",
    "sourceHash": "7e3a567e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "how.title": {
    "text": "விலைப்பட்டியல்<br/><accent>எப்படிச் செல்கிறது</accent>",
    "sourceHash": "1e14d5a4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "how.lead": {
    "text": "InvoiceNow, Access Point-கள் (அணுகல் முனையங்கள்) மூலம் வணிகங்களுக்கு இடையே விலைப்பட்டியல்களை அனுப்பி, விலைப்பட்டியல் தரவை IRAS-க்குத் தெரிவிக்கிறது. அது எப்படிச் செல்கிறது என்பது நீங்கள் அனுப்புகிறீர்களா பெறுகிறீர்களா, மற்ற வணிகமும் InvoiceNow-வில் உள்ளதா என்பதைப் பொறுத்தது.",
    "sourceHash": "3e2cc109",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.eyebrow": {
    "text": "உங்களுக்குத் தேவையானவை",
    "sourceHash": "f56c0f90",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.peppolTitle": {
    "text": "ஒரு Peppol ID",
    "sourceHash": "e8ef1f25",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.peppolBody": {
    "text": "InvoiceNow வலையமைப்பில் உங்கள் வணிகத்தின் தனித்துவமான முகவரி. உங்கள் UEN (தனித்துவ நிறுவன அடையாள எண்) கொண்டு SG Peppol Directory-இல் உங்கள் வணிகத்தைப் பதிவுசெய்யுமாறு உங்கள் IRSP அல்லது Access Point வழங்குநரிடம் கேளுங்கள்.",
    "sourceHash": "c81f93ed",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.irspTitle": {
    "text": "InvoiceNow-Ready தீர்வு வழங்குநர் (IRSP) அல்லது Access Point (AP)",
    "sourceHash": "7a0d12d1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.irspBody": {
    "text": "அங்கீகாரம் பெற்ற Access Point (அணுகல் முனையம்) மூலம் வலையமைப்புடன் ஏற்கெனவே இணைக்கப்பட்ட கணக்கியல் அல்லது நிதி மென்பொருளை IRSP வழங்குகிறது. உங்கள் சொந்த உள்ளக அமைப்பைப் பயன்படுத்தினால், IMDA அங்கீகாரம் பெற்ற Access Point வழங்குநர் மூலம் அதை இணைக்கிறீர்கள்.",
    "sourceHash": "a97d60a9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.find": {
    "text": "IRSP அல்லது Access Point-ஐக் கண்டறி",
    "sourceHash": "d57d2f54",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.label": {
    "text": "நிறுவனப் பெயர் அல்லது UEN மூலம் தேடுங்கள்",
    "sourceHash": "281e0185",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.placeholder": {
    "text": "நிறுவனப் பெயர் அல்லது UEN, எ.கா. 201538812W",
    "sourceHash": "43c52a01",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.aria": {
    "text": "நிறுவனப் பெயர் அல்லது UEN",
    "sourceHash": "f2805234",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.check": {
    "text": "Peppol ID-ஐச் சரிபார்",
    "sourceHash": "6e66803a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.searching": {
    "text": "தேடுகிறது…",
    "sourceHash": "2713de23",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.invalid": {
    "text": "உங்கள் நிறுவனப் பெயரில் குறைந்தது 2 எழுத்துகளை அல்லது உங்கள் UEN-ஐத் தட்டச்சு செய்யுங்கள்.",
    "sourceHash": "cd611560",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.unreachable": {
    "text": "இப்போது Peppol Directory-ஐ அணுக முடியவில்லை. சிறிது நேரம் கழித்து மீண்டும் முயலுங்கள்.",
    "sourceHash": "55d71974",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.found": {
    "text": "<b>கிடைத்தது:</b> {{name}} <id>{{peppolId}}</id>. நீங்கள் பயன்படுத்தத் திட்டமிடும் வழங்குநருடன் அது இணைக்கப்பட்டுள்ளதா என்று உறுதிசெய்வதே உங்கள் அடுத்த வேலை.",
    "sourceHash": "0ee87f4c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.registered": {
    "text": "பதிவுசெய்யப்பட்டது",
    "sourceHash": "cdc6d0e1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.notFound": {
    "text": "Peppol Directory-இல் கிடைக்கவில்லை. நீங்கள் இன்னும் சேரவில்லை என்றால் இது இயல்பானது. உங்கள் IRSP அல்லது Access Point வழங்குநர் அதை உங்களுக்காகப் பதிவுசெய்வார். <lnk>வழங்குநரைக் கண்டறி</lnk>",
    "sourceHash": "d932ee7a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.notFoundName": {
    "text": "அந்தப் பெயருக்குப் பொருத்தம் இல்லை. முழுப் பதிவுப் பெயரையோ உங்கள் UEN-ஐயோ முயலுங்கள். இன்னும் பதிவுசெய்யவில்லையா? உங்கள் IRSP அல்லது Access Point வழங்குநர் அதை உங்களுக்காகப் பதிவுசெய்வார். <lnk>வழங்குநரைக் கண்டறி</lnk>",
    "sourceHash": "9b1ed20e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.matches": {
    "text": "Peppol Directory-இல் பொருத்தங்கள்: {{total}}. உங்கள் வணிகம் பட்டியலில் இருந்தால், அதற்கு ஏற்கெனவே Peppol ID உள்ளது. நீங்கள் பயன்படுத்தத் திட்டமிடும் வழங்குநருடன் அது இணைக்கப்பட்டுள்ளதா என்று உறுதிசெய்வதே உங்கள் அடுத்த வேலை.",
    "sourceHash": "e1ddae9e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.more": {
    "text": "{{total}} இல் {{shown}} காட்டப்படுகின்றன. தேடலைக் குறைக்க, பெயரை மேலும் தட்டச்சு செய்யுங்கள் அல்லது உங்கள் UEN-ஐப் பயன்படுத்துங்கள்.",
    "sourceHash": "57697379",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.iAm": {
    "text": "நான்…",
    "sourceHash": "cc41e59d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.supplier": {
    "text": "விற்பனையாளர், விலைப்பட்டியல் அனுப்புபவர்",
    "sourceHash": "0d5706bb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.customer": {
    "text": "வாடிக்கையாளர், விலைப்பட்டியல் பெறுபவர்",
    "sourceHash": "95463d1f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.who": {
    "text": "INVOICENOW-வில் யார் இருக்கிறார்கள்?",
    "sourceHash": "92863170",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.both": {
    "text": "நாங்கள் இருவரும்",
    "sourceHash": "63fcdba9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.me": {
    "text": "நான் மட்டும்",
    "sourceHash": "d9d30f77",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.lane.iras": {
    "text": "IRAS",
    "sourceHash": "7be84b1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.lane.network": {
    "text": "INVOICENOW வலையமைப்பு",
    "sourceHash": "5c121afe",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.lane.businesses": {
    "text": "உங்கள் வணிகங்கள்",
    "sourceHash": "76356c38",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.offline": {
    "text": "PDF · மின்னஞ்சல் · காகிதம்",
    "sourceHash": "11632b2b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.supplier": {
    "text": "விற்பனையாளர்",
    "sourceHash": "b167f229",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.customer": {
    "text": "வாடிக்கையாளர்",
    "sourceHash": "09f3c039",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.iras": {
    "text": "IRAS",
    "sourceHash": "7be84b1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.yours": {
    "text": "உங்கள் தீர்வு",
    "sourceHash": "cc62bba5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.theirs": {
    "text": "அவர்களின் தீர்வு",
    "sourceHash": "39bcf11e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.sub.notOn": {
    "text": "INVOICENOW-வில் இல்லை",
    "sourceHash": "3afb6658",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.sub.notNetwork": {
    "text": "வலையமைப்பில் இல்லை",
    "sourceHash": "5a6334b5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.sub.tax": {
    "text": "வரி ஆணையம்",
    "sourceHash": "af6c504f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.sub.ap": {
    "text": "ACCESS POINT",
    "sourceHash": "59953bcd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.you": {
    "text": "நீங்கள்",
    "sourceHash": "956decfc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.play": {
    "text": "அசைவூட்டத்தை இயக்கு",
    "sourceHash": "874eb831",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.pause": {
    "text": "அசைவூட்டத்தை நிறுத்து",
    "sourceHash": "52d63d7f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.stepAria": {
    "text": "படி {{n}}: {{title}}",
    "sourceHash": "d1fceddf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.legend.invoice": {
    "text": "விலைப்பட்டியல்",
    "sourceHash": "cf85b330",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.legend.data": {
    "text": "IRAS-க்கு நகல்",
    "sourceHash": "4bdb87b0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.legend.offline": {
    "text": "வலையமைப்புக்கு வெளியே நகல்",
    "sourceHash": "7a61372e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.tag.parallel": {
    "text": "ஒரே நேரத்தில்",
    "sourceHash": "a39f2315",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.tag.offNetwork": {
    "text": "வலையமைப்புக்கு வெளியே",
    "sourceHash": "29b6c97c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.toPartner": {
    "text": "விலைப்பட்டியல் → உங்கள் வணிகப் பங்காளி",
    "sourceHash": "a7f05d67",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.toIras": {
    "text": "விலைப்பட்டியல் தரவு → IRAS",
    "sourceHash": "b82901d9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.headline": {
    "text": "நீங்கள் அனுப்புகிறீர்கள், உங்கள் வாடிக்கையாளரும் InvoiceNow-வில் உள்ளார்",
    "sourceHash": "54087a5e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.toBusiness": {
    "text": "InvoiceNow வலையமைப்பு வழியாக: உங்கள் Access Point, Peppol விலைப்பட்டியலைக் கட்டமைக்கப்பட்ட தரவாக உங்கள் வாடிக்கையாளரின் Access Point-க்கு அனுப்புகிறது.",
    "sourceHash": "c4869be7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.toIras": {
    "text": "Type 1A சமர்ப்பிப்பு: விலைப்பட்டியல் உங்கள் வாடிக்கையாளரின் Access Point-க்கு அனுப்பப்பட்டவுடன், Peppol விலைப்பட்டியலின் நகல் தானாகவே IRAS-க்குச் செல்கிறது. பின்னர் உங்கள் வாடிக்கையாளர் தங்கள் சொந்த நகலைச் சமர்ப்பிக்கிறார் (Type 1B).",
    "sourceHash": "2a8da6a8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.0.title": {
    "text": "வழங்குதல்",
    "sourceHash": "600895e0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.0.text": {
    "text": "உங்கள் InvoiceNow-Ready தீர்வில் Peppol விலைப்பட்டியலை வழங்கி, உங்கள் Access Point-க்கு அனுப்புகிறீர்கள். GST சரிபார்ப்பு வசதியுள்ள தீர்வுகள், GST தவறாக விதிக்கப்பட்டால் உங்களை எச்சரிக்கும்.",
    "sourceHash": "e1466257",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.1.title": {
    "text": "அனுப்பி IRAS-க்கு நகல்",
    "sourceHash": "ce947cc3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.1.text": {
    "text": "உங்கள் Access Point விலைப்பட்டியலை உங்கள் வாடிக்கையாளரின் Access Point-க்கு அனுப்புகிறது. அனுப்பியவுடன், Peppol விலைப்பட்டியலின் நகல் தானாகவே IRAS-க்குச் செல்கிறது.",
    "sourceHash": "1cbd8bb4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.2.title": {
    "text": "சேர்ப்பித்தல்",
    "sourceHash": "4955b9ae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.2.text": {
    "text": "உங்கள் வாடிக்கையாளரின் Access Point விலைப்பட்டியலை உங்கள் வாடிக்கையாளரிடம் சேர்க்கிறது.",
    "sourceHash": "feb817ca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.3.title": {
    "text": "வாடிக்கையாளரும் சமர்ப்பிக்கிறார்",
    "sourceHash": "0dc2f06c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.3.text": {
    "text": "உங்கள் வாடிக்கையாளர் தங்கள் தீர்வில் விலைப்பட்டியலை ஏற்று, GST கொள்முதல் விவரங்களைப் பதிவுசெய்கிறார். அவர்களின் Access Point அந்தக் கொள்முதலின் Solution-extracted நகலை IRAS-க்கு அனுப்புகிறது.",
    "sourceHash": "11484894",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.headline": {
    "text": "நீங்கள் அனுப்புகிறீர்கள், ஆனால் உங்கள் வாடிக்கையாளர் InvoiceNow-வில் இல்லை",
    "sourceHash": "76ea01b7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.toBusiness": {
    "text": "வலையமைப்புக்கு வெளியே: இன்று போலவே உங்கள் வாடிக்கையாளருக்குக் காகித அல்லது PDF விலைப்பட்டியல் தருகிறீர்கள்.",
    "sourceHash": "b3e17818",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.toIras": {
    "text": "Type 2 சமர்ப்பிப்பு: உங்கள் தீர்வு விலைப்பட்டியலைப் பிரித்தெடுத்து, உங்கள் Access Point அதை IRAS-க்கு அனுப்புகிறது. POS விற்பனை அல்லது எளிய வரி விலைப்பட்டியல்கள் போன்ற தொகுத்த விநியோகங்களுக்கும் இது பொருந்தும்.",
    "sourceHash": "6490082d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.0.title": {
    "text": "வழங்கிப் பதிவுசெய்தல்",
    "sourceHash": "e9ec0b9a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.0.text": {
    "text": "உங்கள் வாடிக்கையாளருக்குக் காகித அல்லது PDF விலைப்பட்டியல் தந்து, விற்பனையை உங்கள் InvoiceNow-Ready தீர்வில் பதிவுசெய்கிறீர்கள். அது வலையமைப்பில் செல்லாது.",
    "sourceHash": "f0271b4a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.1.title": {
    "text": "பிரித்தெடுத்துத் தெரிவித்தல்",
    "sourceHash": "abfdc6cf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.1.text": {
    "text": "உங்கள் தீர்வு Solution-extracted விலைப்பட்டியலை உங்கள் Access Point-க்குச் சமர்ப்பிக்கிறது; அது IRAS-க்கு அனுப்புகிறது.",
    "sourceHash": "03c42d61",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.headline": {
    "text": "நீங்கள் பெறுகிறீர்கள், உங்கள் விற்பனையாளரும் InvoiceNow-வில் உள்ளார்",
    "sourceHash": "f5fe09d5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.toBusiness": {
    "text": "InvoiceNow வலையமைப்பு வழியாக: உங்கள் விற்பனையாளரின் Access Point, Peppol விலைப்பட்டியலைக் கட்டமைக்கப்பட்ட தரவாக உங்கள் Access Point-க்கு அனுப்புகிறது.",
    "sourceHash": "d7e9df9a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.toIras": {
    "text": "Type 1B சமர்ப்பிப்பு: நீங்கள் விலைப்பட்டியலை ஏற்ற பிறகு, உங்கள் கொள்முதலின் Solution-extracted நகல் உங்கள் Access Point மூலம் IRAS-க்குச் செல்கிறது. உங்கள் விற்பனையாளரின் Peppol நகல் (Type 1A) தனியாக அனுப்பப்படுகிறது.",
    "sourceHash": "b3a58971",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.0.title": {
    "text": "வழங்குதல்",
    "sourceHash": "600895e0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.0.text": {
    "text": "உங்கள் விற்பனையாளர் தங்கள் InvoiceNow-Ready தீர்வில் Peppol விலைப்பட்டியலை வழங்குகிறார்.",
    "sourceHash": "c8d431ad",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.1.title": {
    "text": "அனுப்புதல்",
    "sourceHash": "f28e14cf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.1.text": {
    "text": "அவர்களின் Access Point அதை உங்கள் Access Point-க்கு அனுப்புகிறது. அனுப்பியவுடன், Peppol விலைப்பட்டியலின் நகல் அவர்கள் தரப்பிலிருந்து IRAS-க்குச் செல்கிறது.",
    "sourceHash": "cda781be",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.2.title": {
    "text": "பெறுதல்",
    "sourceHash": "2e823442",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.2.text": {
    "text": "உங்கள் Access Point விலைப்பட்டியலைத் தரவாக உங்களிடம் சேர்க்கிறது; மீண்டும் தட்டச்சு செய்ய வேண்டியதில்லை.",
    "sourceHash": "32aaf536",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.3.title": {
    "text": "ஏற்றுத் தெரிவித்தல்",
    "sourceHash": "242bc2b6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.3.text": {
    "text": "உங்கள் தீர்வில் அதைச் சரிபார்த்து ஏற்கிறீர்கள்; GST வகை, கொள்முதல் தொகை, கோர வேண்டிய உள்ளீட்டு வரி ஆகியவற்றைத் தேர்ந்தெடுக்கிறீர்கள். Solution-extracted நகல் உங்கள் Access Point மூலம் IRAS-க்குச் செல்கிறது.",
    "sourceHash": "06b6a288",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.headline": {
    "text": "நீங்கள் பெறுகிறீர்கள், ஆனால் உங்கள் விற்பனையாளர் InvoiceNow-வில் இல்லை",
    "sourceHash": "6cbebde0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.toBusiness": {
    "text": "வலையமைப்புக்கு வெளியே: இன்று போலவே விலைப்பட்டியல் PDF அல்லது காகிதமாக உங்களை அடைகிறது.",
    "sourceHash": "58c597f9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.toIras": {
    "text": "Type 3 சமர்ப்பிப்பு: உங்கள் தீர்வு கொள்முதலைப் பிரித்தெடுத்து, உங்கள் Access Point அதை IRAS-க்கு அனுப்புகிறது. சில்லறைப் பணம் போன்ற தொகுத்த கொள்முதல்களுக்கும் இது பொருந்தும்.",
    "sourceHash": "8de06b13",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.0.title": {
    "text": "பெறுதல்",
    "sourceHash": "2e823442",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.0.text": {
    "text": "உங்கள் விற்பனையாளர் உங்களுக்குக் காகித அல்லது PDF விலைப்பட்டியல் அனுப்புகிறார். அது வலையமைப்பில் செல்லாது.",
    "sourceHash": "2391b008",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.1.title": {
    "text": "பதிவுசெய்தல்",
    "sourceHash": "9f4565ec",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.1.text": {
    "text": "கொள்முதலை உங்கள் InvoiceNow-Ready தீர்வில் பதிவுசெய்கிறீர்கள். GST சரிபார்ப்பு வசதியுள்ள தீர்வுகள், GST தவறாக விதிக்கப்பட்டால் உங்களை எச்சரிக்கும்.",
    "sourceHash": "97271995",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.2.title": {
    "text": "பிரித்தெடுத்துத் தெரிவித்தல்",
    "sourceHash": "abfdc6cf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.2.text": {
    "text": "உங்கள் தீர்வு Solution-extracted விலைப்பட்டியலை உங்கள் Access Point-க்கு அனுப்புகிறது; அது IRAS-க்கு அனுப்புகிறது.",
    "sourceHash": "739a8ecb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.eyebrow": {
    "text": "தேர்ந்தெடுக்க உதவுங்கள்",
    "sourceHash": "6024c28d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.title": {
    "text": "எனக்கு எந்த விருப்பம் பொருந்தும்?",
    "sourceHash": "5ee3747e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.q3": {
    "text": "1. நீங்கள் எத்தனை விலைப்பட்டியல்களை வழங்குகிறீர்கள், பெறுகிறீர்கள்?",
    "sourceHash": "e86275b7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.low": {
    "text": "குறைவு",
    "sourceHash": "b1dd9521",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.lowSub": {
    "text": "மாதத்துக்குச் சில",
    "sourceHash": "581a6e39",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.medium": {
    "text": "நடுத்தரம்",
    "sourceHash": "09be5f96",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.mediumSub": {
    "text": "மாதத்துக்குப் பல பத்துகள்",
    "sourceHash": "a096dc27",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.high": {
    "text": "அதிகம்",
    "sourceHash": "be0a061d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.highSub": {
    "text": "நூற்றுக்கணக்கில் அல்லது அதற்கு மேல்",
    "sourceHash": "2ec41bc2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.q4": {
    "text": "2. இன்று விலைப்பட்டியலுக்கு எதைப் பயன்படுத்துகிறீர்கள்?",
    "sourceHash": "3c5f9fa5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.manual": {
    "text": "கைமுறை",
    "sourceHash": "f819f303",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.manualSub": {
    "text": "Word, Excel, PDF",
    "sourceHash": "b775770f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.software": {
    "text": "கணக்கியல் மென்பொருள்",
    "sourceHash": "5e9c3af1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.softwareSub": {
    "text": "தயார்நிலை மென்பொருள்",
    "sourceHash": "fa76f995",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.custom": {
    "text": "ERP அல்லது உள்ளக அமைப்பு",
    "sourceHash": "670dde48",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.customSub": {
    "text": "தனிப்பயன் அல்லது ஒருங்கிணைந்தது",
    "sourceHash": "4263e83c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.empty": {
    "text": "இரண்டு கேள்விகளுக்குப் பதில் அளியுங்கள்; முதலில் பார்க்க வேண்டிய தீர்வு வகையைப் பரிந்துரைப்போம்.",
    "sourceHash": "30e1ee9e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.disclaimer": {
    "text": "பொது வழிகாட்டல் மட்டுமே. முடிவெடுக்கும் முன் IMDA, IRAS, வழங்குநரிடம் தகுதி, விலை, கிடைக்கும் நிலையைச் சரிபாருங்கள்.",
    "sourceHash": "d6a0edc2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.route.kicker": {
    "text": "பரிந்துரைக்கப்பட்ட வழி",
    "sourceHash": "ffe36e89",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.name": {
    "text": "இலவச (FOC) தீர்வு",
    "sourceHash": "361ea5f3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.what": {
    "text": "GST பதிவு பெற்ற வணிகங்களுக்கான இலவச InvoiceNow தொகுப்புகளை IMDA பட்டியலிடுகிறது. சில விலைப்பட்டியல்களை மட்டும் வழங்கி, இன்று விரிதாள், Word அல்லது PDF பயன்படுத்தும் வணிகங்களுக்கு அவை பொருந்தலாம்.",
    "sourceHash": "31792265",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.0": {
    "text": "IMDA-வின் இலவசத் தொகுப்புப் பட்டியலிலிருந்து ஒரு தொகுப்பைத் தேர்ந்தெடுங்கள். தொடக்க, முடிவுத் தேதிகள் வழங்குநருக்கு வழங்குநர் மாறுபடும்; நீங்கள் தேர்ந்தெடுப்பதன் தேதிகளைச் சரிபாருங்கள்.",
    "sourceHash": "0330ed6e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.1": {
    "text": "பதிவுசெய்து, பின்னர் வழங்குநர் மூலம் உங்கள் Peppol ID-ஐ (UEN அடிப்படையிலான ID) பதிவுசெய்யுங்கள்.",
    "sourceHash": "0a9e08c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.2": {
    "text": "உங்கள் தொடக்கத் தேதிக்கு முன் சோதனை விலைப்பட்டியல் அனுப்பி, தரவு IRAS-ஐ அடைவதை உறுதிசெய்யுங்கள்.",
    "sourceHash": "cc0a2a77",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.name": {
    "text": "InvoiceNow-Ready தீர்வு வழங்குநர் (IRSP)",
    "sourceHash": "8503d344",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.what": {
    "text": "உள்ளமைந்த Access Point இணைப்புள்ள கணக்கியல் அல்லது விலைப்பட்டியல் மென்பொருள்; எனவே விலைப்பட்டியல்களும் IRAS தரவுச் சமர்ப்பிப்பும் நீங்கள் ஏற்கெனவே பயன்படுத்தும் கருவியிலிருந்தே நடக்கும்.",
    "sourceHash": "158cc89a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.0": {
    "text": "IMDA-வின் InvoiceNow-Ready தீர்வு வழங்குநர் பட்டியலைச் சரிபாருங்கள். உங்கள் தற்போதைய மென்பொருள் அதில் இருந்தால், InvoiceNow-ஐ எப்படி இயக்குவது என்று விற்பனையாளரிடம் கேளுங்கள்.",
    "sourceHash": "8f638a12",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.1": {
    "text": "இல்லையென்றால், உங்கள் விலைப்பட்டியல் அளவுக்கும் வரவுசெலவுக்கும் ஏற்ற, பட்டியலில் உள்ள ஒரு வழங்குநரைத் தேர்ந்தெடுங்கள்.",
    "sourceHash": "c256493e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.2": {
    "text": "வழங்குநர் உங்கள் Peppol ID-ஐப் பதிவுசெய்யட்டும்; பின்னர் உங்கள் தொடக்கத் தேதிக்கு முன் அனுப்புதலைச் சோதியுங்கள்.",
    "sourceHash": "b2ccef6b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.name": {
    "text": "Peppol Access Point (AP) வழங்குநர்",
    "sourceHash": "c8495985",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.what": {
    "text": "உங்கள் சொந்த அமைப்பை (ERP அல்லது உள்ளக அமைப்பு) வலையமைப்புடன் இணைக்கும் வழங்குநர். நீங்கள் கட்டுப்படுத்தும் மென்பொருள் விலைப்பட்டியல்களை உருவாக்கும்போது அல்லது அதிக அளவில் இருக்கும்போது சிறந்தது.",
    "sourceHash": "1263b849",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.0": {
    "text": "உங்கள் விலைப்பட்டியல்களை உருவாக்கும், பெறும் அமைப்புகளையும், ஒருங்கிணைப்பை யார் பராமரிக்கிறார்கள் என்பதையும் பட்டியலிடுங்கள்.",
    "sourceHash": "be87739d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.1": {
    "text": "IMDA-வின் Access Point வழங்குநர் பட்டியலிலிருந்து தேர்ந்தெடுத்து, அவர்கள் உங்கள் அமைப்பின் ஏற்றுமதி வடிவத்தை ஆதரிக்கிறார்களா என்று உறுதிசெய்யுங்கள்.",
    "sourceHash": "f461faa6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.2": {
    "text": "Access Point மூலம் உங்கள் Peppol ID-ஐப் பதிவுசெய்து, IRAS தரவுச் சமர்ப்பிப்பு உட்பட முழுமையான சோதனைகளை இயக்குங்கள்.",
    "sourceHash": "016ac0c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.link.iras": {
    "text": "IRAS தேவைப் பக்கம்",
    "sourceHash": "1068e5ec",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.link.foc": {
    "text": "இலவசத் தொகுப்புப் பட்டியல்",
    "sourceHash": "9ee3fb61",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.link.ap": {
    "text": "Access Point பட்டியல்",
    "sourceHash": "f269f97f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.link.irsp": {
    "text": "IRSP பட்டியல்",
    "sourceHash": "c2af4eb3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.eyebrow": {
    "text": "பயனுள்ள இணைப்புகள்",
    "sourceHash": "e36a7c96",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.title": {
    "text": "ஒவ்வொரு இணைப்பும், <accent>விளக்கத்துடன்</accent>",
    "sourceHash": "401b26c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.eyebrow": {
    "text": "பற்றி",
    "sourceHash": "4475af1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.title": {
    "text": "சுயாதீனமானது, <accent>அதிகாரபூர்வமற்றது</accent>, மூலங்களுடன்",
    "sourceHash": "3a1f5b49",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.who.title": {
    "text": "இந்தத் தளத்தை யார் நடத்துகிறார்கள்",
    "sourceHash": "c75f38fc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.who.body": {
    "text": "InvoiceNow Hub ஒரு சுயாதீன இணையதளம். இது சிங்கப்பூர் உள்நாட்டு வருவாய் ஆணையம் (IRAS) அல்லது தகவல் தொடர்பு ஊடக மேம்பாட்டு ஆணையத்தால் (IMDA) நடத்தப்படவில்லை, அங்கீகரிக்கப்படவில்லை, அவற்றுடன் தொடர்புடையதும் அல்ல.",
    "sourceHash": "6d510d85",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.why.title": {
    "text": "இது ஏன் உள்ளது",
    "sourceHash": "9f7701ba",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.why.body": {
    "text": "GST InvoiceNow Requirement பற்றிய அதிகாரபூர்வ தகவல்கள் பல IRAS, IMDA இணையப் பக்கங்களிலும் PDF-களிலும் சிதறிக் கிடக்கின்றன. இந்தத் தளம் அவற்றை எளிய மொழியில் ஒரே இடத்தில் தொகுத்து, ஒவ்வொரு கூற்றையும் அதைக் கூறும் அதிகாரபூர்வ ஆவணத்துடன் இணைக்கிறது.",
    "sourceHash": "e283fb73",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.unofficial.title": {
    "text": "இது அதிகாரபூர்வமற்றது",
    "sourceHash": "efb0b4c6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.unofficial.body": {
    "text": "இங்குள்ள எதுவும் சட்ட அல்லது வரி ஆலோசனை அல்ல; MyTaxMail மூலம் IRAS உங்களுக்கு அனுப்பும் நடைமுறைத் தேதிக்கு மாற்றும் அல்ல. இங்குள்ள எதுவும் IRAS அல்லது IMDA-விலிருந்து வேறுபட்டால், அதிகாரபூர்வ மூலமே சரி.",
    "sourceHash": "83ce30b0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.unofficial.channels": {
    "text": "உங்கள் சொந்த வணிகம் தொடர்பான எதற்கும், அதிகாரபூர்வ வழிகளைப் பயன்படுத்துங்கள்: <iras>IRAS GST InvoiceNow queries form</iras> அல்லது <imda>IMDA InvoiceNow contact form</imda>.",
    "sourceHash": "e46d2c5c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.translations.title": {
    "text": "மொழிபெயர்ப்புகள்",
    "sourceHash": "5901bcad",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.translations.body": {
    "text": "சீன, மலாய் மற்றும் தமிழ் பதிப்புகள் ஆங்கில உரையின் அதிகாரப்பூர்வமற்ற மொழிபெயர்ப்புகள். ஆங்கிலப் பதிப்பே மேலோங்கும். தாய்மொழி பேசுபவர் இன்னும் சரிபார்க்காத மொழிபெயர்ப்புகள் ஒவ்வொரு பக்கத்தின் மேலே வரைவு எனக் குறிக்கப்படும்; ஆங்கில உரை மாறினால், மொழிபெயர்ப்பு புதுப்பிக்கப்படும் வரை ஆங்கிலம் காட்டப்படும்.",
    "sourceHash": "6c37be80",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.title": {
    "text": "உள்ளடக்கம் எப்படிச் சரிபார்க்கப்படுகிறது",
    "sourceHash": "10eb8ce1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.body": {
    "text": "ஒவ்வொரு தேதி, வரம்பு, தொகை, கேள்வி-பதில், இணைப்பும் ஒரே தரவுக் கோப்பில் சேமிக்கப்படுகிறது; அதனுடன் அதிகாரபூர்வ மூலத்தின் URL, சரியான கேள்வி அல்லது பத்தி எண், கடைசியாகச் சரிபார்த்த தேதி ஆகியவையும் உள்ளன. பக்கங்கள், தேடுபொறிகளுக்கான கேள்வி-பதில் தரவு, <txt>எளிய உரைப் பதிப்பு</txt> அனைத்தும் அந்தக் கோப்பிலிருந்தே உருவாக்கப்படுவதால், அவை ஒன்றுக்கொன்று முரண்பட முடியாது. ஒவ்வொரு மூல இணைப்பும் இன்னும் செயல்படுகிறதா என்று ஒரு தானியங்கிச் சோதனை உறுதிசெய்து, கடந்த 30 நாட்களில் மீண்டும் சரிபார்க்கப்படாதவற்றைக் குறிக்கிறது.",
    "sourceHash": "94cb7fe2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.last": {
    "text": "உள்ளடக்கம் அதிகாரபூர்வ மூலங்களுடன் கடைசியாக <b>{{date}}</b> அன்று சரிபார்க்கப்பட்டது. இந்தத் தளம் சார்ந்திருக்கும் ஒரே மூலங்கள் இவைதான்:",
    "sourceHash": "9cbd5c33",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.checked": {
    "text": "சரிபார்த்தது {{date}}",
    "sourceHash": "c8a58a32",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.changelog": {
    "text": "உள்ளடக்கத்தில் செய்யப்படும் ஒவ்வொரு மாற்றமும் அதன் தேதியுடன் <lnk>மாற்றப் பதிவில்</lnk> பட்டியலிடப்பட்டுள்ளது.",
    "sourceHash": "5fa09f15",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.title": {
    "text": "தனியுரிமை",
    "sourceHash": "ebfa87e7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.lead": {
    "text": "இந்தத் தளம் உங்கள் பெயர், மின்னஞ்சல் அல்லது எந்தக் கணக்கையும் கேட்பதில்லை. இதன் சொந்தக் குறியீடு எந்த விளம்பர ஸ்கிரிப்ட்டையும் ஏற்றுவதில்லை.",
    "sourceHash": "6e9962e9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.checklist": {
    "text": "<b>சரிபார்ப்புப் பட்டியல்:</b> “இப்போது என்ன செய்வது” நீங்கள் எத்தனை படிகளைக் குறித்துள்ளீர்கள் என்பதை (ஒரு எண்) உங்கள் உலாவியின் உள்ளூர்ச் சேமிப்பில் சேமிக்கிறது; அடுத்த முறையும் அது இருக்கும். அது உங்கள் சாதனத்தை விட்டு வெளியேறுவதில்லை. அதை நீக்க “பட்டியலை மீட்டமை” என்பதைப் பயன்படுத்துங்கள் அல்லது இந்தத் தளத்தின் தரவை அழியுங்கள்.",
    "sourceHash": "05dc1042",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.display": {
    "text": "<b>காட்சி அமைப்புகள்:</b> தொடக்க அசைவூட்டத்தைப் பார்த்தீர்களா, சரிபார்ப்புப் பட்டியல் குறுக்குவழியை மூடினீர்களா என்பவை அமர்வுச் சேமிப்பில் வைக்கப்படுகின்றன; தாவலை மூடும்போது உலாவி அவற்றை அழிக்கும்.",
    "sourceHash": "a8983f5e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.language": {
    "text": "<b>மொழி:</b> மொழி மாற்றியைக் கொண்டு ஒரு மொழியைத் தேர்ந்தெடுத்தால், தளம் உங்களைத் திசைதிருப்பாமல் இருக்க ஒரு சிறிய குக்கீ உங்கள் தேர்வை நினைவில் கொள்ளும். அதில் மொழிக் குறியீடு மட்டுமே இருக்கும்.",
    "sourceHash": "c1e811cb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.calc": {
    "text": "<b>தேதிக் கணிப்பானும் “எனக்கு எந்த விருப்பம் பொருந்தும்?” கருவியும்:</b> முழுவதும் உங்கள் உலாவியிலேயே இயங்குகின்றன, எதையும் சேமிப்பதில்லை.",
    "sourceHash": "20c08d6b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.peppol": {
    "text": "<b>Peppol ID சரிபார்ப்பு:</b> நீங்கள் தட்டச்சு செய்யும் நிறுவனப் பெயர் அல்லது UEN தேடலுக்காகப் பொது Peppol Directory-க்கு (directory.peppol.eu) அனுப்பப்படும். வேறு எதுவும் அனுப்பப்படுவதில்லை; தளத்தின் குறியீடு அதைச் சேமிப்பதும் இல்லை.",
    "sourceHash": "69907a85",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.fonts": {
    "text": "<b>எழுத்துருக்கள்:</b> மூன்றாம் தரப்பிடமிருந்து அல்ல, இந்தத் தளத்திலிருந்தே வழங்கப்படுகின்றன.",
    "sourceHash": "14122bb3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.analytics": {
    "text": "<b>பகுப்பாய்வு:</b> எங்கள் வழங்கியான Cloudflare தற்போது Cloudflare Web Analytics-ஐ இயக்கியுள்ளது. அது static.cloudflareinsights.com-இலிருந்து ஒரு ஸ்கிரிப்ட்டைச் சேர்த்து, பக்கப் பார்வைத் தரவை Cloudflare-க்கு அனுப்புகிறது. இது இந்தத் தளத்தின் குறியீட்டின் பகுதி அல்ல; அது நிறுத்தப்பட்டால் இந்தக் குறிப்பு புதுப்பிக்கப்படும்.",
    "sourceHash": "b75fb1d9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "changelog.eyebrow": {
    "text": "மாற்றப் பதிவு",
    "sourceHash": "8628b339",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "changelog.title": {
    "text": "என்ன மாறியது, <accent>எப்போது</accent>",
    "sourceHash": "8357f12f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "changelog.lead": {
    "text": "இந்தத் தளத்தின் ஒவ்வொரு உள்ளடக்க மாற்றமும், புதியது முதலில். தகவல்கள் <lnk>பற்றி பக்கத்தில்</lnk> பட்டியலிடப்பட்டுள்ள அதிகாரபூர்வ IRAS, IMDA மூலங்களுடன் சரிபார்க்கப்படுகின்றன.",
    "sourceHash": "9335307d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "notfound.title": {
    "text": "பக்கம் <accent>கிடைக்கவில்லை</accent>",
    "sourceHash": "abb2b9fa",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "notfound.body": {
    "text": "இந்த முகவரியில் பக்கம் எதுவும் இல்லை. தளம் தலைப்புவாரிப் பக்கங்களாகப் பிரிக்கப்பட்டபோது அது இடம் மாறியிருக்கலாம்.",
    "sourceHash": "1786edf3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "notfound.home": {
    "text": "முகப்புப் பக்கத்துக்குச் செல்",
    "sourceHash": "6fe7cf79",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "notfound.links": {
    "text": "பயனுள்ள இணைப்புகள்",
    "sourceHash": "237d6316",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  }
}
